import { AxiosError } from 'axios'

import { ErrorField } from '@models/apiBase'

import TypeUtil from './typeUtil'

export type ResponseError = {
  code: number
  message: string
  errors: Array<ErrorField>
}

interface IAxiosUtil {
  isAxiosError: (err: unknown) => err is AxiosError<ResponseError>

  progressEventToPercent: (ev: ProgressEvent) => number

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  extractContentDisposition: (contentDisposition: string) => Record<string, any>
}

const AxiosUtil: IAxiosUtil = {
  isAxiosError: (err): err is AxiosError<ResponseError> => {
    return TypeUtil.isObject(err) && err.isAxiosError
  },

  progressEventToPercent: (ev) => {
    return (ev.loaded / ev.total) * 100
  },

  extractContentDisposition: (contentDisposition) => {
    return contentDisposition.split(';').reduce((prev, next) => {
      let [key, value] = next.split('=')
      key = key.trim()

      const hasValue = TypeUtil.isDefined(value)
      if (hasValue && value.startsWith('"') && value.endsWith('"')) {
        value = value.substring(1, value.length - 1)
      }

      prev[key] = hasValue ? value : null
      return prev
    }, Object())
  },
}

export default AxiosUtil
